import { Box, Button, Typography, styled } from "@mui/material";
import { colors } from "../../theme/colors";

export const StepCounter = styled(Typography)({
  fontSize: "16px",
  color: colors.text.secondary,
  fontFamily: "Nunito",
  fontWeight: 400,
  display: "inline",
  marginLeft: "8px",
});

export const RejectionCommentBox = styled(Box)({
  backgroundColor: colors.background.red,
  borderRadius: "16px",
  padding: "16px",
  margin: "32px 0",
});

export const RejectionCommentTitle = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.text.error,
  fontFamily: "Sora",
  marginBottom: "4px",
});

export const RejectionCommentText = styled(Typography)({
  fontSize: "16px",
  color: colors.text.error,
  fontFamily: "Nunito",
  lineHeight: "24px",
});

export const ViewToggleContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  borderRadius: "6px",
  border: `1px solid ${colors.border.medium}`,
  overflow: "hidden",
});

export const ViewToggleButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isActive",
})<{ isActive?: boolean }>(({ isActive }) => ({
  height: "48px",
  minWidth: "130px",
  borderRadius: 0,
  border: "none",
  borderRight: `1px solid ${colors.border.medium}`,
  fontFamily: "Nunito",
  fontSize: "16px",
  fontWeight: isActive ? 700 : 400,
  color: isActive ? colors.primary.main : colors.text.secondary,
  backgroundColor: isActive ? colors.background.lightBlue : colors.background.secondary,
  textTransform: "none",
  "&:last-of-type": {
    borderRight: "none",
  },
  "&:hover": {
    backgroundColor: isActive ? colors.background.lightBlue : colors.background.default,
  },
}));
